<template>
  <div>
    <header-page ref="headerPage"></header-page>
    <div class="content-box">
      <div class="layout-main" v-if="routers && routers.length > 0" :style="defaultHeight">
        <div class="layout-left">
          <div class="leftSidebar-main">
            <div class="nav-menu-body" id="headerMenu">
              <el-menu
                class="sidebar-el-menu"
                background-color="#344058"
                text-color="#fff"
                active-text-color="#fff"
                unique-opened
                router
              >
                <template v-for="item in routers">
                  <template v-if="item.children">
                    <el-submenu :index="item.index" :key="item.index">
                      <template slot="title">
                        <i :class="item.menuIcon"></i>
                        <span>{{ item.meta != null ? item.meta.title : ''}}</span>
                      </template>
                      <template v-for="subItem in item.children">
                        <el-submenu v-if="subItem.children" :index="subItem.name" :key="subItem.name">
                          <template slot="title">{{ subItem.meta != null ? subItem.meta.title : '' }}</template>
                          <el-menu-item
                            v-for="(threeItem, i) in subItem.children"
                            :key="i"
                            :index="threeItem.name"
                          >{{ threeItem.meta != null ? threeItem.meta.title : '' }}</el-menu-item>
                        </el-submenu>
                        <el-menu-item
                          v-else
                          :index="subItem.name"
                          :key="subItem.name"
                        >{{ subItem.meta != null ? subItem.meta.title : '' }}</el-menu-item>
                      </template>
                    </el-submenu>
                  </template>
                  <template v-else>
                    <el-menu-item :index="item.name" :key="item.name">
                      <i :class="item.menuIcon"></i>
                      <template #title>{{ item.meta.title }}</template>
                    </el-menu-item>
                  </template>
                </template>
              </el-menu>
            </div>
          </div>
        </div>
        <div class="layout-right">
          <router-view v-slot="{ Component }" :key="$route.name">
            <transition name="move" mode="out-in">
              <component :is="Component" />
            </transition>
          </router-view>
        </div>
      </div>
      <div class="content" :style="defaultHeight" v-else>
        <router-view v-slot="{ Component }" :key="$route.name">
          <transition name="move" mode="out-in">
            <component :is="Component" />
          </transition>
        </router-view>
      </div>
    </div>
  </div>
</template>

<script>
import headerPage from './HeaderPage'
import LeftSidebar from './LeftSidebar'
import vTags from "../../Tags.vue";
import {mapGetters} from "vuex";
export default {
  name: "index",
  data() {
    return {
      routers: [],
      defaultHeight: {
        height: ""
      },
    };
  },
  components: {
    headerPage,
    LeftSidebar,
    vTags
  },
  watch: {
    '$route': 'defaultLeftNavOpened'  //监听router值改变时，改变导航菜单激活项
  },
  computed: {
    tagsList() {
      return this.$store.state.tagsList.map(item => item.name);
    },
    ...mapGetters([
      'routesLists'
    ]),
  },
  methods: {
    //定义方法，获取高度减去头尾
    getHeight() {
      this.defaultHeight.height = window.innerHeight - 80 + "px";
    },
    // 左侧导航栏根据当前路径默认打开子菜单（如果当前路由是三级，则父级子菜单默认打开）
    defaultLeftNavOpened () {
      let cur_path = this.$route.path; //获取当前路由
      let routers = []; // 获取路由对象
      let routesLists = this.routesLists;
      let topName = "";
      if(this.$route && this.$route.meta && this.$route.meta.topName){
          topName = this.$route.meta.topName;
      }
      for(let i = 0; i < routesLists.length; i++){
        if(routesLists[i].name == topName && routesLists[i].children && routesLists[i].children.length > 0){
          routers = routesLists[i].children
        }
      }

      console.log('++++++++leftNav+++++++++++++++++++++++++++++++++++++++++=');
      console.log(topName);
      console.log(routers);
      console.log('+++++++++++++++++++++++++++++++++++++++++++++++++=');

      let subMenuIndex = 0, needOpenSubmenu = false;
      for (let i = 0; i < routers.length; i++) {
        let children = routers[i].children;
        if(children){
          for (let j = 0; j < children.length; j++) {
            if (children[j].path === cur_path) {
              break;
            }
            // 如果该菜单下有子菜单(个数>1且设置的leaf为false才有下拉子菜单)
            if(children[j].children && !children[j].leaf) {
              let grandChildren = children[j].children;
              for(let z=0; z<grandChildren.length; z++) {
                if(grandChildren[z].path === cur_path) {
                  subMenuIndex = j;
                  needOpenSubmenu = true;
                  break;
                }
              }
            }
          }
        }
      }
      if(this.$refs['leftNavigation'] && needOpenSubmenu) {
        this.$refs['leftNavigation'].open(subMenuIndex); // 打开子菜单
      }

      this.routers = routers;

    },
  },
  created() {
    console.log('进来了');
    //页面创建时执行一次getHeight进行赋值，顺道绑定resize事件
    window.addEventListener("resize", this.getHeight);
    this.getHeight();

  },
  mounted() {
    this.defaultLeftNavOpened();
  }
}
</script>

<style scoped>
.content{
  background: #efefef;
}
</style>



// WEBPACK FOOTER //
// src/components/theme/theme2/index.vue